import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashColorful = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFDD55",
			d: "M9.001 0L9.00098 17.998L8.99902 17.999C4.02882 17.9989 5.849e-06 13.9692 1.3063e-05 8.99902C5.43173e-05 4.02884 4.02887 7.73924e-05 8.99905 0H9.001Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFAA01",
			d: "M9.00342 15.9207L8.64698 15.9119C4.98933 15.7264 2.08058 12.7015 2.08058 8.9978C2.08079 5.1747 5.18028 2.07593 9.00344 2.07593L9.00342 15.9207Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFE577",
			d: "M9.00051 0L9.00049 17.998L9.00146 17.999C13.9717 17.999 18.0005 13.9692 18.0005 8.99902C18.0005 4.02883 13.9717 5.7305e-05 9.00149 0H9.00051Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFBB34",
			d: "M9.00245 15.9199L9.35889 15.9111C13.0165 15.7257 15.9251 12.7017 15.9253 8.99805C15.9253 5.17477 12.8258 2.0752 9.00247 2.0752L9.00245 15.9199Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFDD55",
			d: "M7.44338 10.3206C7.58804 11.2126 7.85387 11.6946 8.92677 11.6946C8.95212 11.6946 8.97715 11.6924 9.00197 11.6916L9.00196 13.9973H8.08302L8.08302 13.0325C7.01021 12.8878 6.03351 12.3338 5.85255 10.6223L7.44338 10.3206ZM9.00198 5.8479C8.26095 5.8508 7.9385 6.21208 7.9385 6.70435C7.93867 7.29707 8.32021 7.59492 9.00197 7.83032L9.00197 9.62134C8.85128 9.57636 8.69219 9.53222 8.52834 9.48853C7.38321 9.18714 6.09377 8.71676 6.09377 6.96899C6.09385 5.61909 7.0217 4.81145 8.17874 4.54614L8.17874 3.46118H9.00198L9.00198 5.8479Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFE577",
			d: "M9.00002 7.83203C9.14963 7.88367 9.31251 7.93571 9.49025 7.9834C10.6837 8.30889 11.9737 8.71881 11.9736 10.4668C11.9736 11.9857 10.9491 12.8172 9.62306 13.0342L9.62306 13.999H9.00001L9.00001 11.6934C9.7063 11.6726 10.1895 11.36 10.1895 10.7197C10.1894 10.0784 9.68047 9.82621 9.00002 9.62305L9.00002 7.83203ZM9.70803 4.53516C10.7928 4.66786 11.6848 5.29518 11.7813 6.80176L10.166 6.99512C10.0576 6.24783 9.80411 5.84975 9.00881 5.84961C9.00602 5.84961 9.00281 5.8496 9.00002 5.84961L9.00003 3.46289H9.70803L9.70803 4.53516Z"
		})
	]
});
const ForwardRef = forwardRef(SvgCashColorful);
export default ForwardRef;
